import React from 'react';

import {
  TableCell,
  TableRow,
  Typography,
} from '../../../base';

import { permissions } from '../../../../constants/permissions';
import { userHasPermission } from '../../../../utils/permissions';
import { renderProperDataFormat } from '../constants';

const JobDesktopView = ({
  styles: s,
  classes: c,
  t,
  gt,
  columns,
  TagJob,
  JobProgress,
  lastStatus,
  additionalInfo,
  data,
  user,
}) => {

  return (
    <TableRow className={s.headerRowStyles}>
      <TableCell>
        {userHasPermission(user, permissions.TAG_INTEREST) ? TagJob : null}
      </TableCell>
      {columns.map(row => {
        return (
          row.data &&
          <TableCell className={s.textColor} key={row.colId}>
            <Typography style={row.colName === 'alerts' ? {display: 'flex', justifyContent: 'center'} : null} variant='body2'>
              {renderProperDataFormat(row, data, gt)}
            </Typography>
          </TableCell>
        )
      })}
    </TableRow>
  );
}

export default JobDesktopView;



// WEBPACK FOOTER //
// ./src/components/Jobs/Job/views/JobDesktop.js